import { OptimisticEventSyncStatus } from "../persistence";

export const SyncIcon = ({
  syncStatus,
  width = 20,
}: {
  syncStatus: OptimisticEventSyncStatus;
  width?: number;
}) => {
  return (
    <span
      style={{
        width,
        height: width,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: "bold",
      }}
    >
      {syncStatus === "synced" ? (
        "🟢"
      ) : syncStatus === "error" ? (
        "🔴"
      ) : syncStatus === "sending" ? (
        <span style={{ color: "green" }}>⇡</span>
      ) : (
        <span style={{ color: "green" }}>⇣</span>
      )}
    </span>
  );
};
